import dynamic from 'next/dynamic';
import hiddenLoading from '../../lib/hiddenLoading';

export default dynamic(() => import('./EmailConfirmationAlert'), {
  ssr: false,
  loading: hiddenLoading,
});
